(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const nav = root.querySelector('.faq-directory__nav');
    const track = root.querySelector('.faq-directory__links');
    let revealTimer;
    const links = [...root.querySelectorAll('.faq-directory__links a')];
    const sections = [...root.querySelectorAll('.faq-directory__category')];
    const header = document.querySelector('.header-section') || document.querySelector('.header');
    let offset = 120;
    let scheduled = false;
    function update() {
      scheduled = false;
      if (!root.isConnected) return;
      let active = sections[0];
      for (const section of sections) if (section.getBoundingClientRect().top <= offset + 30) active = section;
      for (const link of links) {
        if (link.hash === `#${active?.id}`) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      }
    }
    function revealActive() {
      if (!root.isConnected || !matchMedia('(max-width: 989px)').matches) return;
      const selected = track.querySelector('[aria-current]');
      if (!selected) return;
      const item = selected.getBoundingClientRect();
      const frame = track.getBoundingClientRect();
      const left = frame.left + 12;
      const right = frame.right - 12;
      const delta = item.left < left ? item.left - left : item.right > right ? item.right - right : 0;
      if (Math.abs(delta) > 1) track.scrollTo({
        left: track.scrollLeft + delta,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
    function schedule() {
      if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
      clearTimeout(revealTimer);
      revealTimer = setTimeout(revealActive, 160);
    }
    function measure() {
      const mobile = matchMedia('(max-width: 989px)').matches;
      const headerHeight = header?.getBoundingClientRect().height || 0;
      offset = headerHeight + (mobile ? nav.offsetHeight : 0) + 24;
      root.style.setProperty('--faq-header-bottom', `${headerHeight}px`);
      root.style.setProperty('--faq-offset', `${offset}px`);
      schedule();
    }
    const observer = new ResizeObserver(measure);
    observer.observe(nav);
    if (header) observer.observe(header);
    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', measure, {passive:true});
    measure();
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) {
        clearTimeout(revealTimer);
        observer.disconnect();
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', measure);
      }
    }, {once:true});
  }
  const start = () => document.querySelectorAll('.faq-directory').forEach(init);
  start();
  document.addEventListener('shopify:section:load', start);
})();
